import Axios from 'axios';
import { Toast } from './common';
import { baseURL } from './config';
const qs = require('qs');
const lang = 'zh';

Axios.defaults.withCredentials = true;
var instance = Axios.create({
  baseURL,
  timeout: 5000,
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
});

let map = {};

instance.interceptors.request.use(
  function(config) {
    if (!config.url.match(/lang=/g)) {
      if (!config.url.match(/\?/g)) {
        config.url += '?lang=' + lang;
      } else {
        config.url += '&lang=' + lang;
      }
    }
    config.headers.token = localStorage.getItem('oauthToken');
    console.log(config.url);
    if (!config.params || config.params.noAddParams != 1) {
      config.url += `&platform=2&timestamp=${+new Date()}`;
    }
    config.data = qs.stringify(config.data);
    map[config.url] = config;

    // 在发送请求之前做些什么
    return config;
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(function(data) {
  if (data.status == 200 && data.data && !data.data.error) {
    data.data.config = data.config;
    return data.data;
  } else {
    return Promise.reject(data);
  }
});

instance.interceptors.response.use(function(res) {
  return new Promise((resolve, reject) => {
    if (res.code == 0) {
      resolve(res.data);
    } else if (res.code == 1000) {
      reject(res.data);
    } else if (res.code == 403) {
      localStorage.removeItem('oauthToken');
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx874544a4f921f3a3&redirect_uri=${encodeURIComponent(
        window.location.href
      )}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`;
    } else {
      reject(res);
    }
  }).catch((err) => {
    if (res.config && res.config.disableErrorAlt) {
      throw err;
    }
    if (err && err.code) {
      Toast(`连接超时,code=${err.code}`);
    } else if (typeof err === 'string') {
      Toast(err);
    }
    throw err;
  });
});

export default instance;
